import { AbstractControl, ValidatorFn, UntypedFormGroup } from '@angular/forms';
import { ITenantIDM } from 'src/app/shared/models/ITenantIDM';
import { IIDN } from '../../../shared/models/IIDN';


export class IdnNameValidator {
  static ValidateName(idns: IIDN[]): ValidatorFn {

    return (control: AbstractControl): { [key: string]: boolean } | null => {

      let controlValue = control.value as string;

      let controlId = (<UntypedFormGroup>control.parent).get('id')?.value as string;

      let existingIdn = idns.find(x => (controlValue && x.name.toLowerCase().trim() == controlValue.toLowerCase().trim()) && (x.id.toString() != controlId));

      return existingIdn ? { errorName: true } : null;
    };

  }

  static ValidateIDN(idns: ITenantIDM[]): ValidatorFn {

    return (control: AbstractControl): { [key: string]: boolean } | null => {

      if (!control.value) {
        return null
      }

      let controlValue = control.value as string;

      let controlId = (<UntypedFormGroup>control.parent).get('id')?.value as string;

      let existingIdn = idns.find(x => (x.name.toLowerCase().trim() == controlValue.toLowerCase().trim()) && (x.id.toString() != controlId));

      return !existingIdn ? { errorIDN: true } : null;
    };

  }

  static ValidateIDNCode(idns: ITenantIDM[], isCreate: boolean): ValidatorFn {

    return (control: AbstractControl): { [key: string]: boolean } | null => {

      if (!control.value) {
        return null
      }

      let controlValue = control.value as string;

      let existingIdn: ITenantIDM;

      let controlIdnName: string = "";
      //Get the value from name combobox Select IDN for creation
      if (isCreate) {
        controlIdnName = (<UntypedFormGroup>control.parent).get('name')?.value as string;
        existingIdn = idns.find(x =>
          (x.code.toLowerCase().trim() == controlValue.toLowerCase().trim()) &&
          (x.name.toLocaleLowerCase().trim() != controlIdnName.toLocaleLowerCase().trim())
        );

      } else {
        ///Get the value from input text IDN name for editing
        controlIdnName = (<UntypedFormGroup>control.parent).get('idnName')?.value as string;
        existingIdn = idns.find(x =>
          (x.code.toLowerCase().trim() == controlValue.toLowerCase().trim()) &&
          (x.name.toLocaleLowerCase().trim() != controlIdnName.toLocaleLowerCase().trim())
        );
      }

      return existingIdn ? { errorName: true } : null;
    };

  }
}
